import React from "react";

import useSettingsState from "../hooks/useSettingsState";

const initialState = {
  isAuthenticated: false,
  isH3Admin: false
};

const UserSettingsContext = React.createContext(initialState);

function UserSettingsProvider({ children }) {
  const [isH3Admin, setIsH3Admin] = useSettingsState("isH3Admin", false);  // Use local storage; state doesn't survive a page refresh
  const [authorities, setAuthorities] = useSettingsState("authorities", []); 
  const [preferences, setPreferences] = useSettingsState("preferences", {});
  const [environment, setEnvironment] = useSettingsState("environment", "dev");
  const [isAuthenticated, setIsAuthenticated] = useSettingsState("isAuthenticated", false);
  const [navbarRefresh, setNavbarRefresh] = useSettingsState("navbarRefresh", 0);
  const [documentsRefresh, setDocumentsRefresh] = useSettingsState("documentsRefresh", 0);
  const [pastHospitalPrivilegesRefresh, setPastHospitalPrivilegesRefresh] = useSettingsState("pastHospitalPrivilegesRefresh", 0);
  const [taskAssigneeRefresh, setTaskAssigneeRefresh] = useSettingsState("taskAssigneeRefresh", 0);
  const [tasksRefresh, setTasksRefresh] = useSettingsState("tasksRefresh", 0);

  return (
    <UserSettingsContext.Provider
      value={{
        isH3Admin,
        setIsH3Admin,
        authorities,
        setAuthorities,
        preferences,
        setPreferences,
        environment,
        setEnvironment,
        isAuthenticated,
        setIsAuthenticated,
        navbarRefresh,
        setNavbarRefresh,
        documentsRefresh,
        setDocumentsRefresh,
        pastHospitalPrivilegesRefresh,
        setPastHospitalPrivilegesRefresh,
        taskAssigneeRefresh,
        setTaskAssigneeRefresh,
        tasksRefresh,
        setTasksRefresh
      }}
    >
      {children}
    </UserSettingsContext.Provider>
  );
}

export { UserSettingsProvider, UserSettingsContext };
